<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em; padding-bottom:15px;">W.L. Burke was born, raised and resides in the rocky mountains. He has been living there for the last 30 years, on a small ranch, raising children, horses, dogs, and various sundry types of animals. Some of those were sold, some were raced, some were rescued, and some are kept around as family.</p>
<p style="text-indent:00em; padding-bottom:15px;">One of five children, the author quit school at 15 and went to work full time, but recommends this option to no one. A life-long love of reading overcame this shortfall, gaining a diploma and taking some college courses, which, prompted some writing attempts.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3b88147c